import type { Dict } from "../en";

export const shell: Dict["shell"] = {
  // The places (the rail, the list columns, the palette's jumps).
  chat: "Trò chuyện",
  team: "Nhóm",
  inbox: "Hộp thư",
  automations: "Tự động hóa",
  admin: "Quản trị",
  navMain: "Điều hướng chính",
  // The rail's foot: the person's menu.
  roleAdmin: "Quản trị viên",
  roleMember: "Thành viên",
  meMenu: "Tùy chọn và đăng xuất",
  preferences: "Tùy chọn",
  signOut: "Đăng xuất",
  // Counts said for screen readers.
  mentionsOfYou_one: "{n} lượt nhắc đến bạn",
  mentionsOfYou_other: "{n} lượt nhắc đến bạn",
  mentionsSr_one: "lượt nhắc đến bạn",
  mentionsSr_other: "lượt nhắc đến bạn",
  unreadCount: "{n} chưa đọc",
  unread: "chưa đọc",
  // The Chat list.
  search: "Tìm kiếm hoặc chuyển đến…",
  newChat: "Cuộc trò chuyện mới",
  newChatTitle: "Bắt đầu cuộc trò chuyện mới với Vantage",
  pinned: "Đã ghim",
  startedByEmail: "Bắt đầu qua email",
  show: "Hiển thị",
  recent: "Gần đây",
  archived: "Đã lưu trữ",
  select: "Chọn",
  yourArchivedChats: "các cuộc trò chuyện đã lưu trữ",
  noArchivedChats: "Chưa có cuộc trò chuyện nào được lưu trữ. Lưu trữ từ menu ⋯ của từng cuộc.",
  archivedHowBack:
    "Để khôi phục, hãy gửi một tin nhắn vào cuộc trò chuyện đó hoặc chọn Khôi phục trong menu ⋯.",
  yourChats: "các cuộc trò chuyện của bạn",
  chatsEmpty: "Các cuộc trò chuyện của bạn sẽ hiện ở đây.",
  otherChats: "Cuộc trò chuyện khác",
  showMore: "Xem thêm",
  // Select mode.
  chats_one: "{n} cuộc trò chuyện",
  chats_other: "{n} cuộc trò chuyện",
  chatsArchived_one: "Đã lưu trữ {n} cuộc trò chuyện",
  chatsArchived_other: "Đã lưu trữ {n} cuộc trò chuyện",
  chatsDeleted_one: "Đã xóa {n} cuộc trò chuyện",
  chatsDeleted_other: "Đã xóa {n} cuộc trò chuyện",
  couldntUnarchive: "Không bỏ lưu trữ được.",
  couldntArchive: "Không lưu trữ được.",
  chatsCouldntDelete: "Không xóa được các cuộc trò chuyện.",
  selectedChats: "Cuộc trò chuyện đã chọn",
  tickChats: "Chọn các cuộc trò chuyện cần lưu trữ hoặc xóa.",
  archiveChats_one: "Lưu trữ {n} cuộc trò chuyện",
  archiveChats_other: "Lưu trữ {n} cuộc trò chuyện",
  deleteChats_one: "Xóa {n} cuộc trò chuyện",
  deleteChats_other: "Xóa {n} cuộc trò chuyện",
  deleteChatsQ_one: "Xóa {n} cuộc trò chuyện?",
  deleteChatsQ_other: "Xóa {n} cuộc trò chuyện?",
  deleteChatsBody:
    "Tin nhắn, câu trả lời của Vantage, cùng các tệp và báo cáo trong đó sẽ bị xóa hết. Sau vài giây nữa sẽ không hoàn tác được.",
  alsoForget: "Đồng thời để Vantage quên những gì đã học được về bạn ở đó",
  // The Team list.
  couldntOpenConversation: "Không mở được cuộc trò chuyện này.",
  newDm: "Tin nhắn riêng mới",
  findSomeone: "Tìm người",
  findSomeoneDots: "Tìm người…",
  noOneMatches: "Không có ai phù hợp.",
  yourChannelsAndMessages: "các kênh và tin nhắn của bạn",
  channels: "Kênh",
  notInChannel: "Bạn chưa tham gia kênh nào.",
  muted: "Đã tắt thông báo",
  directMessages: "Tin nhắn riêng",
  noDms: "Chưa có tin nhắn riêng nào.",
  // The Inbox list.
  filterByType: "Lọc theo loại",
  showOnly: "Chỉ hiện",
  markAllRead: "Đánh dấu tất cả đã đọc",
  inboxSub: "Từ Vantage, dành cho bạn",
  showEverything: "Hiện lại tất cả",
  inboxDidntLoad: "Không tải được Hộp thư",
  due: "Đến hạn {when}",
  loadMore: "Tải thêm",
  // The Admin list.
  people: "Thành viên",
  teams: "Nhóm",
  memory: "Bộ nhớ",
  feedback: "Phản hồi",
  auditLog: "Nhật ký thay đổi",
  settings: "Cài đặt",
  active: "Đang hoạt động",
  newCount: "{n} mới",
  newNoAccess: "{n} mục mới chưa được cấp quyền truy cập",
  // The palette.
  messages: "Tin nhắn",
  files: "Tệp",
  notes: "Ghi chú",
  directMessage: "Tin nhắn riêng",
  newChatWithVantage: "Cuộc trò chuyện mới với Vantage",
  jumpTo: "Chuyển đến",
  adminJump: "Quản trị: {page}",
  chatWithVantage: "Trò chuyện với Vantage",
  channel: "Kênh",
  conversations: "Cuộc trò chuyện",
  file: "Tệp",
  teamNoteIn: "#{slug} · ghi chú nhóm",
  teamNote: "Ghi chú nhóm",
  teamNotes: "Ghi chú nhóm",
  searchOrJump: "Tìm kiếm hoặc chuyển đến",
  fromPerson: "Người gửi",
  fromAnyone: "Bất kỳ ai",
  nameYou: "{name} (bạn)",
  inPlace: "Trong",
  anywhere: "Mọi nơi",
  date: "Ngày",
  fromDate: "Từ ngày",
  toDate: "Đến ngày",
  clear: "Bỏ chọn",
  hasFile: "Có tệp",
  clearFilters: "Bỏ bộ lọc",
  kind: "Loại",
  results: "Kết quả",
  couldntSearch: "Không tìm kiếm được lúc này.",
  searching: "Đang tìm…",
  nothingMatches: "Không có kết quả phù hợp.",
  // The bell.
  notifications: "Thông báo",
  notificationsNew: "Thông báo ({n} mới)",
  yourNotifications: "thông báo của bạn",
  notificationsEmpty: "Chưa có gì mới. Lượt nhắc đến bạn và trả lời sẽ hiện ở đây.",
  now: "vừa xong",
  dismissNotification: "Đóng thông báo",
  // The version, the connection bar.
  copyVersion: "Sao chép phiên bản",
  versionCopied: "Đã sao chép phiên bản",
  reconnecting: "Đang kết nối lại…",
  reconnectNow: "Kết nối lại ngay",
  // Someone's presence, typing.
  isOnline: "{name} đang trực tuyến",
  isAway: "{name} đang vắng mặt",
  isOffline: "{name} đang ngoại tuyến",
  typingOne: "{name} đang nhập…",
  typingTwo: "{a} và {b} đang nhập…",
  typingMany: "Nhiều người đang nhập…",
  // A team's colours, access levels.
  hueBlue: "Xanh dương",
  hueTeal: "Xanh ngọc",
  hueViolet: "Tím",
  huePink: "Hồng",
  hueAmber: "Hổ phách",
  hueGreen: "Xanh lá",
  hueGrey: "Xám",
  levelNone: "Không",
  levelRead: "Xem",
  levelWrite: "Sửa",
  levelManage: "Quản lý",
  // Sign-in.
  tagline: "Đồng đội AI của Busy Cube",
  couldntReach: "Không kết nối được với Vantage. Hãy thử lại.",
  signIn: "Đăng nhập",
  signInIntro: "Nhập email Busy Cube của bạn, chúng tôi sẽ gửi một liên kết dùng một lần.",
  email: "Email",
  emailMeLink: "Gửi liên kết đăng nhập qua email",
  onlyAdded: "Chỉ những người được quản trị viên thêm vào mới đăng nhập được.",
  checkEmail: "Kiểm tra email của bạn",
  linkSent:
    "Nếu {email} là email của một người ở đây, liên kết đăng nhập đang được gửi đến. Liên kết chỉ dùng được một lần và hết hạn sau 15 phút.",
  codeLabel: "Đang dùng ứng dụng đã cài? Hãy nhập mã 6 chữ số",
  signInWithCode: "Đăng nhập bằng mã",
  resendLink: "Gửi lại liên kết",
  sentAgainAt: "Đã gửi lại lúc {time}. Hãy dùng email mới nhất.",
  differentEmail: "Dùng email khác",
  linkUsedTitle: "Liên kết này đã được dùng",
  linkUsedBody:
    "Mỗi liên kết đăng nhập chỉ dùng được một lần. Hãy yêu cầu liên kết mới và dùng trong vòng 15 phút.",
  linkExpiredTitle: "Liên kết này đã hết hạn",
  linkExpiredBody: "Liên kết đăng nhập chỉ có hiệu lực trong 15 phút. Hãy yêu cầu liên kết mới.",
  linkInvalidTitle: "Liên kết này không dùng được",
  linkInvalidBody: "Có thể liên kết chỉ được sao chép một phần. Hãy yêu cầu liên kết mới.",
  askNewLink: "Yêu cầu liên kết mới",
  signInToVantage: "Đăng nhập vào Vantage",
  linkReady: "Liên kết đã sẵn sàng. Nhấn Đăng nhập để tiếp tục trên thiết bị này.",
  // Pages that aren't the app's.
  pageNotFound: "Không tìm thấy trang",
  pageNotFoundBody: "Trang này không tồn tại hoặc đã được chuyển đi.",
  goHome: "Về trang chủ",
  somethingWentWrong: "Đã có lỗi xảy ra",
  errorBody:
    "Trang này gặp lỗi. Tải lại trang thường sẽ khắc phục được; nếu không, hãy báo quản trị viên.",
  reload: "Tải lại",
  adminsOnly: "Chỉ dành cho quản trị viên",
  adminsOnlyHeading: "Chỉ quản trị viên mới mở được trang này",
  adminsOnlyBody: "Nếu cần thay đổi gì ở đây, hãy nhờ quản trị viên.",
  // Notifications on this device (push), the live connection.
  pushInsecure:
    "Thông báo cần kết nối bảo mật (https). Hãy mở Vantage EX bằng địa chỉ https để bật thông báo.",
  pushInstall:
    "Trên iPad hoặc iPhone, trước tiên hãy thêm Vantage EX vào Màn hình chính (Chia sẻ → Thêm vào MH chính), rồi mở từ đó và bật thông báo.",
  pushUnsupported: "Trình duyệt này không hiển thị được thông báo từ Vantage EX.",
  pushNoKey: "Máy chủ này chưa thiết lập thông báo. Quản trị viên có thể bật tính năng này.",
  pushDenied:
    "Thông báo của Vantage EX đang bị chặn. Hãy cho phép trong cài đặt trang web của trình duyệt rồi thử lại.",
  pushDeniedIos:
    "Thông báo của Vantage EX đang bị chặn. Trên iPhone hoặc iPad, mở Cài đặt → Thông báo → Vantage EX, bật Cho phép thông báo rồi thử lại.",
  pushDeniedAndroid:
    "Thông báo của Vantage EX đang bị chặn. Chạm và giữ biểu tượng Vantage, chọn Thông tin ứng dụng → Thông báo, bật thông báo rồi thử lại.",
  noLongerIn: "Bạn không còn ở trong {name}.",
};
